<template>
    <div class="Power_copy">
        <me-collapes @collapesCb="collapesCb" :treeTitle="'采集点选择'" :style="`width:calc(${treeOuterWidth}px + 40px)`">
            <!-- <div class="tree-wrap"> -->
            <me-tree
                ref="myTree"
                :treeData="data"
                :treeLoading="treeLoading"
                :treeToolBar="false"
                :defaultProps="defaultProps"
                :nodeKey="'point_id'"
                :showCheckbox="true"
                :title="'采集点选择'"
                :cascadingVar="true"
                :checkStrictly.sync="checkStrictly"
                :isCheckClick="true"
                :defaultCheckKeys="defaultCheckKeys"
                @handleCheckBoxClick="handleTreeNodeClick"
                @handleStretchClick="handleStretchClick"
            ></me-tree>
            <!--  :defaultExpandedKeys="defaultCheckKeys" -->
            <!-- </div> -->
        </me-collapes>
        <div class="right_container" :style="`width:calc(100% - ${treeOuterWidth}px - 40px)`">
            <div class="search_cont">
                <el-form
                    :model="searchForm"
                    :inline="true"
                    ref="searchForm"
                    class="leader-style-form"
                >
                    <el-form-item class="select-date" label="开始日期">
                        <el-date-picker
                            v-model="searchForm.startDate"
                            align="right"
                            type="date"
                            :clearable="false"
                            :picker-options="startPickerOptions"
                            format="yyyy-MM-dd"
                            value-format="yyyy-MM-dd"
                            placeholder="选择日期"
                            v-if="true"
                        ></el-date-picker>
                    </el-form-item>
                    <el-form-item class="select-item" label="时">
                        <el-select
                            v-model="searchForm.startHour"
                            placeholder="请选择"
                        >
                            <el-option
                                v-for="item in hourList"
                                :key="item"
                                :label="item"
                                :value="item"
                            ></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item class="select-item" label="分">
                        <el-select
                            v-model="searchForm.startMin"
                            placeholder="请选择"
                        >
                            <el-option
                                v-for="item in minuteList"
                                :key="item"
                                :label="item"
                                :value="item"
                            ></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item class="select-date" label="截至日期">
                        <el-date-picker
                            v-model="searchForm.endDate"
                            align="right"
                            type="date"
                            :clearable="false"
                            :picker-options="pickerOptions"
                            format="yyyy-MM-dd"
                            value-format="yyyy-MM-dd"
                            placeholder="选择日期"
                            v-if="true"
                        ></el-date-picker>
                    </el-form-item>
                    <el-form-item class="select-item" label="时">
                        <el-select
                            v-model="searchForm.endHour"
                            placeholder="请选择"
                        >
                            <el-option
                                v-for="item in hourList"
                                :key="item"
                                :label="item"
                                :value="item"
                            ></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item class="select-item" label="分">
                        <el-select
                            v-model="searchForm.endMin"
                            placeholder="请选择"
                        >
                            <el-option
                                v-for="item in minuteList"
                                :key="item"
                                :label="item"
                                :value="item"
                            ></el-option>
                        </el-select>
                    </el-form-item>
                    <div
                        class="btn-wrap"
                        style="float:right;margin-right:10px;"
                    >
                        <el-button
                            type="warning"
                            size="medium"
                            @click="handleSearchList()"
                           class="leader-search_s"
                            >查询</el-button
                        >
                        <el-button
                            type="primary"
                            size="medium"
                            @click="handleExportExl()"
                            class="leader-search_s"
                            >导出</el-button
                        >
                    </div>
                </el-form>
            </div>
            <div class="table-wrap">
                <!-- <div class="title">
                    <div class="blue"></div>
                    电能集抄
                </div>-->
                <el-scrollbar style="height: 95%">
                    <el-table
                        v-loading="tableLoading"
                        :data="tableData"
                        border
                        style="width: 100%"
                        class="leader-style-table"
                    >
                        <el-table-column
                            align="center"
                            prop="point_name"
                            label="回路名称"
                        ></el-table-column>
                        <el-table-column
                            align="center"
                            prop="start_time"
                            label="起始时间"
                        ></el-table-column>
                        <el-table-column
                            align="center"
                            prop="start_num"
                            label="起始数值"
                        ></el-table-column>
                        <el-table-column
                            align="center"
                            prop="end_time"
                            label="截止时间"
                        ></el-table-column>
                        <el-table-column
                            align="center"
                            prop="end_num"
                            label="截止数值"
                        ></el-table-column>
                        <el-table-column
                            align="center"
                            prop="sub_num"
                            label="电量(kWh)"
                        ></el-table-column>
                    </el-table>
                </el-scrollbar>
            </div>
        </div>
    </div>
</template>
<script>
import Tree from "@/comon/components/tree.vue";
import * as api from "@/http/api.js";
import Collapes from "@/comon/components/collapse-block.vue";
import moment from "moment";
import {
    getEnergyList,
    getCollectionExcel
} from "@/http/energy-report-collection.js";
export default {
    components: {
        "me-tree": Tree,
        "me-collapes": Collapes
    },
    data() {
        return {
            treeOuterWidth: 280,
            tableData: [],
            hourList: [
                "00",
                "01",
                "02",
                "03",
                "04",
                "05",
                "06",
                "07",
                "08",
                "09",
                "10",
                "11",
                "12",
                "13",
                "14",
                "15",
                "16",
                "17",
                "18",
                "19",
                "20",
                "21",
                "22",
                "23"
            ],
            minuteList: [],
            data: [],
            treeLoading: false,
            defaultProps: {
                children: "childList",
                label: "point_name"
            },
            select_type: "search",
            checkStrictly: true,
            defaultCheckKeys: [],
            nodeKey: "point_id",
            searchForm: {
                startDate: "",
                startHour: "00",
                startMin: "00",
                endDate: "",
                endHour: "00",
                endMin: "00"
            },
            pickerOptions: {
                disabledDate(time) {
                    return time.getTime() > Date.now();
                }
            },
            startPickerOptions: {
                disabledDate: time => {
                    return (
                        time.getTime() >
                        new Date(this.searchForm.endDate).getTime()
                    );
                }
            },
            tableLoading: false,
            width: "calc(100% - 300px)"
        };
    },
    created() {
        // this.searchForm.endDate = this.getSysDate();
        // this.searchForm.startDate = moment(new Date(this.searchForm.endDate)).subtract(7, 'days')
        //     .format('YYYY-MM-DD');
        this.getSysDate();
        this.minuteList = [];
        for (let i = 0; i < 60; i++) {
            const min = i;
            if (i < 10) {
                min = `0${i}`;
            }
            this.minuteList.push(min);
        }
    },
    mounted() {},
    methods: {
        /**
         * 获取系统时间
         */
        getSysDate() {
            api.getSysDate().then(res => {
                if (res && res.error_code === "0") {
                    this.searchForm.endDate = res.bus_json.sysdate;
                    this.searchForm.startDate = moment(
                        new Date(this.searchForm.endDate)
                    )
                        .subtract(7, "days")
                        .format("YYYY-MM-DD");
                    this.getUnitPointList();
                }
            });
        },
        /**
         * 获取时间值
         * params{type<string>} type = day(日) type = month(月) type = year(年)
         */
        getTimeValue(type) {
            let date = new Date();
            if (type === "year") {
                return date.getFullYear() + "";
            } else if (type === "month") {
                return date.getFullYear() + "-" + (date.getMonth() + 1);
            } else {
                return (
                    date.getFullYear() +
                    "-" +
                    (date.getMonth() + 1) +
                    "-" +
                    date.getDate()
                );
            }
        },
        /**
         * 格式化tree disabled状态；
         */
        tickMenuIdFilter: () => {
            let resultArr = new Array();
            let firstPoint = new Object();
            let getTickMenuId = function(obj) {
                if (
                    undefined === obj ||
                    null === obj ||
                    !(obj instanceof Object)
                ) {
                    return;
                }
                if (obj.state === "1") {
                    //实采集点
                    obj.disabled = true;
                    resultArr.push(obj.id);
                } else if (obj.state === "0") {
                    //虚点
                    if (!firstPoint.point_id) {
                        firstPoint = obj;
                    }
                }

                if (null != obj.childList && obj.childList instanceof Array) {
                    for (let child of obj.childList) {
                        getTickMenuId(child);
                    }
                }
            };

            return {
                filter: function(arr) {
                    if (!(arr instanceof Array)) {
                        return false;
                    }
                    resultArr = new Array();
                    firstPoint = new Object();
                    for (let rootMenu of arr) {
                        getTickMenuId(rootMenu);
                    }
                    return { tree: resultArr, firstPoint: firstPoint };
                }
            };
        },
        handleTreeNodeClick(select) {
            this.defaultCheckKeys = this.$refs.myTree.$refs.tree.getCheckedKeys();
            // this.defaultExpandedKeys = [select.point_id];
        },
        handleStretchClick(treeOuterWidth) {
            this.treeOuterWidth = treeOuterWidth;
        },
        /**
         * 获取采集点信息
         */
        getUnitPointList() {
            this.treeLoading = true;
            api.getUnitPointList({ point_class_id: "001" }).then(res => {
                if (res && res.error_code === "0") {
                    this.data = res.bus_json;
                    let formatData = this.tickMenuIdFilter().filter(
                        res.bus_json
                    );
                    this.defaultCheckKeys = [formatData.firstPoint.point_id];
                    this.getEnergyList();
                }
                this.treeLoading = false;
            });
        },
        /**
         * 获取用能集抄-列表
         */
        getEnergyList() {
            let params = {};
            let point_ids = this.defaultCheckKeys.join(",") + ",";
            params = {
                point_ids: point_ids,
                start_time:
                    this.searchForm.startDate +
                    " " +
                    this.searchForm.startHour +
                    ":" +
                    this.searchForm.startMin +
                    ":00",
                end_time:
                    this.searchForm.endDate +
                    " " +
                    this.searchForm.endHour +
                    ":" +
                    this.searchForm.endMin +
                    ":00"
            };
            this.tableLoading = true;
            getEnergyList(params).then(res => {
                if (res && res.error_code === "0") {
                    this.tableData = res.bus_json;
                }
                this.tableLoading = false;
            });
        },
        /**
         * 搜索
         */
        handleSearchList() { 
            if (!this.defaultCheckKeys.length) {
                this.$message({
                    message: "请选择节点后进行查询操作！",
                    type: "warning"
                });
                return;
            }
            let startHour = this.searchForm.startHour * 1;
            let endHour = this.searchForm.endHour * 1;
            let startMin = this.searchForm.startMin * 1;
            let endMin = this.searchForm.endMin * 1;
            if (
                new Date(this.searchForm.startDate).getTime() ===
                new Date(this.searchForm.endDate).getTime()
            ) {
                if (startHour > endHour) {
                    this.$message({
                        message: "起始日期必须小于截止日期！",
                        type: "warning"
                    });
                    return;
                } else if (startHour === endHour) {
                    if (startMin >= endMin) {
                        this.$message({
                            message: "起始日期必须小于截止日期！",
                            type: "warning"
                        });
                        return;
                    }
                }
            }else if(
                new Date(this.searchForm.startDate).getTime() >
                new Date(this.searchForm.endDate).getTime()
            ){
                this.$message({
                    message: "起始日期必须小于截止日期！",
                    type: "warning"
                });
                return;
            }

            this.getEnergyList();
        },
        /**
         * 导出excel表格
         */
        handleExportExl() {
            
            // 判断 
            if (!this.defaultCheckKeys.length) {
                this.$message({
                    message: "请选择节点后进行查询操作！",
                    type: "warning"
                });
                return;
            }
            let startHour = this.searchForm.startHour * 1;
            let endHour = this.searchForm.endHour * 1;
            let startMin = this.searchForm.startMin * 1;
            let endMin = this.searchForm.endMin * 1;
            if (
                new Date(this.searchForm.startDate).getTime() ===
                new Date(this.searchForm.endDate).getTime()
            ) {
                if (startHour > endHour) {
                    this.$message({
                        message: "起始日期必须小于截止日期！",
                        type: "warning"
                    });
                    return;
                } else if (startHour === endHour) {
                    if (startMin >= endMin) {
                        this.$message({
                            message: "起始日期必须小于截止日期！",
                            type: "warning"
                        });
                        return;
                    }
                }
            }else if(
                new Date(this.searchForm.startDate).getTime() >
                new Date(this.searchForm.endDate).getTime()
            ){
                this.$message({
                    message: "起始日期必须小于截止日期！",
                    type: "warning"
                });
                return;
            }


            let params = {};
            let point_ids = this.defaultCheckKeys.join(",") + ",";
            params = {
                point_ids: point_ids,
                start_time:
                    this.searchForm.startDate +
                    " " +
                    this.searchForm.startHour +
                    ":" +
                    this.searchForm.startMin +
                    ":00",
                end_time:
                    this.searchForm.endDate +
                    " " +
                    this.searchForm.endHour +
                    ":" +
                    this.searchForm.endMin +
                    ":00"
            };
            const loading = this.$loading({
                lock: true,
                text: "下载中",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)"
            });
            getCollectionExcel(params).then(res => {
                if (res) {
                    const content = res;
                    const blob = new Blob([content]);
                    const fileName =
                        params.start_time + "-" + params.end_time + ".xlsx";
                    if (window.navigator.msSaveOrOpenBlob) {
                        navigator.msSaveBlob(blob, fileName);
                    } else {
                        let link = document.createElement("a");
                        link.href = window.URL.createObjectURL(blob);
                        link.download = fileName;
                        document.body.appendChild(link);
                        let evt = document.createEvent("MouseEvents");
                        evt.initEvent("click", false, false);
                        link.dispatchEvent(evt);
                        document.body.removeChild(link);
                    }
                    this.$message({
                        message: "下载成功！",
                        type: "success"
                    });
                }
                loading.close();
            });
        },
        /**
         * 监听树结构收起展开
         */
        collapesCb(collapes) {
            this.width = collapes ? "calc(100% - 300px)" : "calc(100% - 56px)";
        }
    }
};
</script>
<style lang="scss">
.Power_copy {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: row;
    box-sizing: border-box;
    padding: 0 1rem 0 0;
    .el-form-item {
        // margin-right: 0 !important;
        .el-form-item__content {
            padding: 0 !important;
        }
    }
    .select-date {
        //   width: px2Rem(188px);
        .el-form-item__content {
            //  width: calc(100% - 70px);
            .el-date-editor.el-input {
                width: 80%;
            }
        }
        .el-input--suffix .el-input__inner {
            width: auto !important;
        }
    }
    .select-item {
        //    width: px2Rem(68px);
        .el-form-item__content {
            // width: calc(100% - 30px);
            .el-select {
                .el-input {
                    width: 68px;
                }
                //width: 100%;
            }
        }
    }
    .leader-search_s:hover{  background: #56fbff;color: #FFF;border:2px solid #FFF;}

 
    .tree-wrap {
        z-index: 0;
        width: px2Rem(280px);
        height: calc(98% - 5px);
        overflow-x: hidden;
        box-sizing: border-box;
        border-radius: 5px;
    }
    .right_container {
        height: calc(98% - 5px);
        margin-top: 5px;
        box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
        border-radius: 5px;
        box-sizing: border-box;
        transition: width 500ms;
        .el-tabs--card {
            margin: 0;
        }
        .search_cont {
            width: 100%;
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            .el-form {
                width: 100%;
                text-align: left;
                padding-top: 15px;
            }
            // .el-input__inner {
            //     height: 36px;
            //     line-height: 36px;
            // }
        }
        .table_cont-wrap {
            width: 100%;
            padding: 0 10px;
            box-sizing: border-box;
            //   overflow: hidden;
            .el-table th {
                padding: 2px 0;
            }
            .title {
                color: #fff;
            }
            .blue {
                height: 12px;
                width: 5px;
                background: #0089f1;
                margin: 10px;
                float: left;
            }
            width: 100%;
            font-size: 16px;
            text-align: left;
            line-height: 32px;
            height: 32px;
        }
    }
}

</style>
